import { render, staticRenderFns } from "./sxqyResearcreport.vue?vue&type=template&id=255ca15a&scoped=true"
import script from "./sxqyResearcreport.vue?vue&type=script&lang=js"
export * from "./sxqyResearcreport.vue?vue&type=script&lang=js"
import style0 from "./sxqyResearcreport.vue?vue&type=style&index=0&id=255ca15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ca15a",
  null
  
)

export default component.exports